import { gql } from "@apollo/client";

export default gql`
  mutation ExportEngagementSurveyHeatmapToCsvMutation(
    $complianceProgramId: Int!
    $groupBy: EngagementSurveyReportGroupBy!
    $teamIds: [Int]
    $managerIds: [Int]
    $managerIdsFullTree: [Int]
    $employeeStartDateRange: [String]
    $locations: [String]
    $collapsedKeys: [String]
  ) {
    exportComplianceProgramEngagementSurveyHeatmapToCsv(
      complianceProgramId: $complianceProgramId
      groupBy: $groupBy
      teamIds: $teamIds
      managerIds: $managerIds
      managerIdsFullTree: $managerIdsFullTree
      employeeStartDateRange: $employeeStartDateRange
      locations: $locations
      collapsedKeys: $collapsedKeys
    ) {
      complianceProgram {
        id
      }
    }
  }
`;
